import React, {
  useState, memo,
} from 'react';
import map from 'lodash/map';
import reject from 'lodash/reject';
import concat from 'lodash/concat';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import { useDispatch } from 'react-redux';
import PaymentOptionGroupItem from '../PaymentOptionGroupItem';
import { handleKeyboardEvent, amountSum } from '../../../../../../../../../../../../../shared/utils/commonUtils';
import { setPaymentPlans } from '../../../../../../../../paymentOptionsSlice';
import { useDeepEffect } from '../../../../../../../../../../../../../shared/utils/customizedHooks';

const PaymentOptionGroups = ({
  groups, currencyCode, locale,
}) => {
  const dispatch = useDispatch();
  const [ paymentPlanOptions, setPaymentPlanOptions ] = useState([]);
  const [ currentAmountDues, setCurrentAmountDues ] = useState([]);

  const handleContentClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const caculatePaymentPlan = ({ paymentPlanObj, currentAmountObj }) => {
    const { groupId } = paymentPlanObj;
    const existPaymentPlanObj = find(paymentPlanOptions, paymentPlanObj);
    if (!existPaymentPlanObj || !isEqual(existPaymentPlanObj, paymentPlanObj)) {
      setPaymentPlanOptions(concat(reject(paymentPlanOptions, { groupId }), [ paymentPlanObj ]));
    }
    if (!find(currentAmountDues, currentAmountObj)) {
      setCurrentAmountDues(concat(reject(currentAmountDues, { groupId }), [ currentAmountObj ]));
    }
  };

  useDeepEffect(() => {
    if (paymentPlanOptions.length === groups.length) {
      let currentAmountDue = 0;
      map(currentAmountDues, (c) => {
        currentAmountDue = amountSum(currentAmountDue, c.currentAmount);
      });
      dispatch(setPaymentPlans({ paymentPlanOptions, currentAmountDue }));
    }
  }, [ paymentPlanOptions, currentAmountDues, groups, dispatch ]);

  return <React.Fragment>
    <div className='hr-solid-line extend-width-20 cui-mg-t-15' />
    <div className="checkout-paymentOption-content" onClick={handleContentClick} onKeyDown={handleKeyboardEvent(handleContentClick, 'Enter')}>
      {
        groups.map((groupItem, index) => {
          return (
            <>
              {index > 0 && <div className='hr-dash-line cui-mg-t-20' />}
              <PaymentOptionGroupItem
                caculatePaymentPlan={caculatePaymentPlan}
                locale={locale}
                currencyCode={currencyCode}
                {...groupItem}
                index={index} key={index}></PaymentOptionGroupItem>
            </>
          );
        })
      }
    </div>
  </React.Fragment>;
};

export default memo(PaymentOptionGroups);
